import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_NOTIFICATION,
  HIDE_NOTIFICATION,
  REMOVE_NOTIFICATION,
  REMOVE_NOTIFICATIONS_BY_TYPE,
  MARK_NOTIFICATIONS_READ,
  SET_ONLINE,
  SET_OFFLINE,
} from './actions';

const initialState = {
  online: true,
  notifications: {}, // see './notification-defaults'
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_NOTIFICATION: {
      const { notification } = action;

      return {
        ...state,
        notifications: {
          ...state.notifications,
          [notification.id]: notification,
        },
      };
    }
    case HIDE_NOTIFICATION: {
      const { id } = action;

      return {
        ...state,
        notifications: {
          ...state.notifications,
          [id]: {
            ...state.notifications[id],
            visible: false,
          },
        },
      };
    }
    case REMOVE_NOTIFICATION: {
      const { id } = action;
      const notifications = { ...state.notifications };
      delete notifications[id];

      return {
        ...state,
        notifications,
      };
    }
    case REMOVE_NOTIFICATIONS_BY_TYPE: {
      const { notificationType } = action;
      const updatedNotifications = Object.values(state.notifications).reduce((acc, n) => {
        if (n.type !== notificationType) {
          acc[n.id] = n;
        }
        return acc;
      }, {});

      return {
        ...state,
        notifications: updatedNotifications,
      };
    }
    case MARK_NOTIFICATIONS_READ: {
      const updatedNotifications = Object.values(state.notifications).reduce(
        (acc, n) => ({
          ...acc,
          [n.id]: { ...n, read: true },
        }),
        {}
      );

      return {
        ...state,
        notifications: updatedNotifications,
      };
    }
    case SET_ONLINE: {
      return {
        ...state,
        online: true,
      };
    }
    case SET_OFFLINE: {
      return {
        ...state,
        online: false,
      };
    }
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return {
        ...state,
        online: true,
        notifications: {},
      };
    }
    default:
      return state;
  }
}

export default reducer;
